/*
 * Copyright (C) 2021 to Present Applause App Quality, Inc. All rights reserved.
 */

import { Inject, Pipe, PipeTransform } from '@angular/core';

import { AVATAR_SERVICE, AvatarService } from './avatar.service';

@Pipe({
    name: 'avatarUrl',
    standalone: false,
    pure: false
})
export class AvatarUrlPipe implements PipeTransform {
  public constructor(@Inject(AVATAR_SERVICE) private avatarService: AvatarService) {
  }

  public transform(userId: number): string {
    return this.avatarService.generateAvatarUrl(userId, true);
  }
}
